import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ControlByRequest } from "src/app/core/services/business/model/control-by-request";
import { ControlByRequestService } from "src/app/core/services/business/service/control-by-request.service";

@Component({
  selector: "app-edit-control-by-request",
  templateUrl: "./edit-control-by-request.component.html",
  styleUrls: ["./edit-control-by-request.component.scss"],
})
export class EditControlByRequestComponent implements OnInit {
  @Input() controlByRequestId;

  controlByRequest: ControlByRequest;

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _controlByRequestService: ControlByRequestService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      avis: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getControlByRequestById(this.controlByRequestId);
  }

  getControlByRequestById(id) {
    this._controlByRequestService.getControlByRequestById(id).subscribe(
      (data) => {
        this.controlByRequest = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.spinner.show();
    this.pressButton = true;
    this._controlByRequestService
      .putControlByRequest(this.controlByRequest)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
